<template>
  <v-timeline-item right icon="message" fill-dot>
    <v-card class="elevation-2">
      <v-card-text>
        {{data.text}}
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Say',
  props: {
    data: Object
  },
}
</script>
